<template>
	<CustomSelect
		:invalid="invalid"
		errorMsg="Please select an assessment provider from the list"
		v-model="institution"
		:options="selectOptions"
		label="Select Assessment Provider"
		@change="updateInstitution"
	>
	</CustomSelect>

</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { mapGetters, mapMutations } from 'vuex';
import { AssessmentEntry, IInstitutionInfo } from '@/models';
import AssessmentEntryValidator from '@/models/validation/AssessmentEntryValidator';
import { IAssessmentProvider } from '@/models/services/collegetransfer/entities';
import CustomSelect from '@/components/CustomSelect.vue';
import config from '@/models/services/config';

@Component({
	methods: mapMutations('wmct', {
		updateLearningInstitution: 'UPDATE_LEARNING_INSTITUTION',
	}),
	computed: mapGetters('wmct', {
		selectOptions: 'assessmentProviderOptions',
	}),
	components: {
		CustomSelect,
	},
})
export default class InstitutionSelect extends Vue {
	@Prop() public value!: AssessmentEntry;

	private selectOptions!: IInstitutionInfo[];
	private updateLearningInstitution!: ({ learning, inst}: {learning: AssessmentEntry, inst: IInstitutionInfo}) => void;

	private get validating() {
		return this.value.isValidating;
	}

	public get invalid() {
		return this.validating && !this.institution;
	}

	public get institution() {
		return this.value.institution.value;
	}

	public updateInstitution(val: any) {
		const selected = this.selectOptions.filter((option: any) => option.value === val)[0];

		this.updateLearningInstitution({ learning: this.value, inst: selected });
	}

	private mounted() {
		if (!this.institution) {
			const refs = this.$refs;
			if (refs === undefined) {
				return;
			}
			const search = refs.search as Vue;
			if (search === undefined) {
				return;
			}
			const searchInput = search.$refs.input as Vue;
			const formInput = searchInput.$el as HTMLElement;

			formInput.focus();
		}
	}
}
</script>
